// extracted by mini-css-extract-plugin
export default {"campaigns":"LandingPageCarousel-module--campaigns--006ce"};